<template>
	<div id="page">
		<div class="ml">
			 <ul>
				<li>
					 <a>{{$route.query.title}}</a>
					 <div class="ml1">
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/gzs.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px; color: rgb(124, 122, 122);">VR宝箱</p>
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/rl.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">欢迎您</p>
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/ml.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">详情页</p>
					 </div>
				</li>
			 </ul>
		</div>
		<!--文字下载部分  -->
		<div v-for="(item,index) in iteminfo" :key="index" class="info">

      <iframe style="height: 700px;width: 100%;" :src='item.url' scrolling='no' border='0' frameborder='no' framespacing='0' allowfullscreen='true'></iframe>
      <Editor
				style="width: 100%;"
				v-model="item.content"
				:defaultConfig="editorConfig"
				:mode="mode"
      />
      <p style="color: cornflowerblue;font-size: 23px;">游戏简介 :</p>
      <br />
      <p v-for="(item,index) in info" :key="index" style="margin-left: 15px;">{{item}}<br><br></p>
      <img v-for="(item,index2) in img" :key="index2+'img'" style="width: 100%; height: 100%;" :src="item">
      <el-button @click="isid" style="margin-top: 80px;margin-bottom:370px;" type="primary" icon="el-icon-download">点我下载</el-button>

      <el-button @click="back" style="margin-top: 80px;margin-bottom:370px;float: right;" type="primary">返回首页</el-button>
    </div>

	</div>
</template>

<script>
	import Vue from 'vue'
	import { Editor} from '@wangeditor/editor-for-vue'

	export default Vue.extend({
    components: { Editor},
		name:'page',
		props:{
			iteminfo:{
				type:Array,
				default(){
          return []
        }
			},
      info:{
      	type:Array,
      	default(){
          return []
        }
      },
      img:{
        type:Array,
        default(){
          return []
        }
      },
		},
		data() {
			return {
					editorConfig: {
						placeholder: '',
						scroll : false,
						readOnly:true
					},
					mode: 'default',
			}
		},
    methods:{
      isid(){
        this.$emit('isclick',this.$route.params.id)
      },
      back(){
        this.$router.go(-1)
      }
    }
	})
</script>

<style scoped>

	/* 编程工具 */
	.ml{
	    /* border: solid 2px #000000; */

			padding: 5px;
	}
	.ml ul li{
			text-align: center;

	    border-bottom: solid 2px #c0c0c0;
	    margin-top: 5px;
	    height: 70px;
	    /* width: 720px; */
	    font-weight: bold;
	}
	.ml ul li a{
	    text-decoration: none;
	    letter-spacing:1px;
			font-size: 20px;

	}
	.ml1 {
		width: 400px;
		/* border: solid 2px #000000; */
		margin: 0 auto;
		padding-left: 12%;
	}
	.info{
		padding: 5px;
	}
</style>
